export const webEndPoint = "https://dev-api.astrocure.co.in/api/v1/";
export const videoCreatorEndPoint = "https://dev-video.astrocure.co.in/api/v1/";